<template>
    <div>
        <Search @callback="handleSearchCallback" :page="page"></Search>
    
        <template v-if="list.length">
            <div class="table_list">
                <el-table
                    v-loading="loading"
                    :data="list"
                    border
                    size="small"
                >
                    <el-table-column
                        v-for="(c, i) in column"
                        :key="i"
                        :label="c.label"
                        :prop="c.prop"
                    ></el-table-column>
                </el-table>
            </div>
            
            <div class="page_preview">
                <el-pagination
                    background
                    layout="prev, pager, next"
                    :current-page="pageNum"
                    :page-size="pageSize"
                    :total="total"
                    @current-change="handleChangePage"
                ></el-pagination>
            </div>
        </template>
        <el-empty v-else description="暂无数据" v-loading="loading"></el-empty>
    </div>
</template>

<script>
import { getPreviewReportList } from '@/apis/advCenter.js';
import Search from './components/Search';
import { getDate } from '@/common/utils';

export default {
    name: 'stay-audit',
    data() {
        return {
            page: 'report',
            search: {
                date: [getDate(-7), getDate()]
            },
    
            loading: false,
            column: [
                { label: '审核时间', prop: 'audit_time' },
                { label: '送审素材数', prop: 'pending_idea_count' },
                { label: '审核素材数', prop: 'review_idea_count' },
                { label: '审核通过数', prop: 'pass_idea_count' },
                { label: '审核率', prop: 'review_rate' },
                { label: '通过通过率', prop: 'pass_rate' },
            ],
            list: [],
            total: 0,
            pageNum: 1,
            pageSize: 20
        }
    },
    
    components: {
        Search
    },
    
    methods: {
        init() {
            this.getList();
        },
        
        async getList() {
            let params = {
                page: this.pageNum,
                page_size: this.pageSize,
            };
    
            if (this.search.date && this.search.date.length) params['audit_time'] = this.search.date[0] + '~' + this.search.date[1];
            if (this.search.collection && this.search.collection.length) params['collection_id'] = this.search.collection.join();
            if (this.search.adSlotId) params['adslot_id'] = this.search.adSlotId.join();
            
            const { code, data } = await getPreviewReportList(params);
            if (code && code === 200) {
                this.list = data.list;
                this.total = data.total;
            }
        },
    
        handleChangePage(n) {
            this.pageNum = n;
        },
        
        handleSearchCallback(data) {
            this.search = {...data};
            this.getList();
        }
    },
    
    mounted() {
        this.init();
    }
}
</script>

<style lang="scss">
.el-table__header-wrapper th.el-table__cell{
    color: #000;
    background: #fafafa;
}
.table_list{
    margin-top: 20px;
}
.page_preview{
    margin-top: 20px;
    padding-bottom: 20px;
    text-align: right;
}
</style>
